export default __webpack_public_path__ + "static/media/Prologue_Haven1US.4f690b9c.svg";